<template>
    <div style="flex-grow: 1; display: flex; flex-direction: column;">
        <div style="display: flex; flex-direction: row; flex-grow: 0;">
            <QInput dense
                    hide-bottom-space
                    placeholder="Search"
                    outlined
                    autocomplete="off"
                    clearable
                    class="q-mb-sm"
                    style="flex-grow: 1;"
                    v-model="searchText">
                <template v-slot:prepend>
                    <QIcon name="mdi-magnify" />
                </template>
            </QInput>
        </div>
        <AgGridVue
                   style="flex-grow: 1; display: flex; flex-direction: column;"
                   v-model="rowData"
                   :columnTypes="columnTypes"
                   :columnDefs="columnDefs"
                   :headerHeight="30"
                   :rowHeight="33"
                   :treeData="true"
                   :treeDataChildrenField="treeDataChildrenField"
                   :autoGroupColumnDef="autoGroupColumnDef"
                   :quickFilterText="searchText"
                   @grid-ready="gridReady"
        >

        </AgGridVue>
    </div>
</template>

<script>
    import { QInput, QIcon } from 'quasar';
    import { AgGridVue } from "ag-grid-vue3";

    export default {
        name: 'flow-v2-debuglocals',
        components: {
            QInput, QIcon,
            AgGridVue

        },
        emits: [],
        props: {
            items: null,
        },
        data() {
            return {
                gridApi: null,
                columnApi: null,

                searchText: '',
                rowData: [],
                columnDefs: [
                    {
                        headerName: 'Value',
                        field: 'value',
                        flex: 1,
                    },
                    {
                        headerName: 'Type',
                        field: 'type',
                        flex: 1,
                    },
                ],
                columnTypes: {
                },
                treeDataChildrenField: 'children',
                autoGroupColumnDef: {
                    headerName: 'Name',
                    field: 'name',
                    cellRendererParams: {
                        suppressCount: true,
                    },
                },
            }
        },
        created() {
            if (this.items)
                this.rowData = [...this.items];
        },
        mounted() {

        },
        computed: {
        },
        watch: {
            items: {
                handler(newv) {
                    this.rowData = Array.isArray(newv) ? newv : [];
                    this.applyRowData();
                },
                deep: true
            },
        },
        beforeUnmount() {
            this.gridApi = null;
            this.columnApi = null;
        },
        methods: {
            applyRowData() {
                if (!this.gridApi)
                    return;
                this.gridApi.setGridOption('rowData', this.rowData);
            },
            gridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;
                this.applyRowData();
            },
        }
    };
</script>
